
const advantages = [
  {
    icon: 'ri-time-line',
    title: '准时交付',
    description: '98%的准时交付率，提供实时货物追踪和状态更新',
  },
  {
    icon: 'ri-shield-check-line',
    title: '安全保障',
    description: '先进的安全措施和全面的货物保险覆盖',
  },
  {
    icon: 'ri-customer-service-2-line',
    title: '全天候服务',
    description: '7×24小时客户服务和物流支持团队',
  },
];

export default function WhyChooseUs() {
  return (
    <section className="py-24 bg-white">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-16">
          <h2 className="text-4xl font-bold text-gray-900 mb-4">
            为什么选择<span className="font-bold">厦门中航嘉禾</span>
          </h2>
        </div>
        <div className="grid md:grid-cols-3 gap-8">
          {advantages.map((item) => (
            <div key={item.title} className="text-center">
              <div className="w-16 h-16 bg-teal-100 rounded-full flex items-center justify-center mx-auto mb-6">
                <i className={`${item.icon} text-3xl text-teal-600`}></i>
              </div>
              <h3 className="text-xl font-bold text-gray-900 mb-3">{item.title}</h3>
              <p className="text-gray-600">{item.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}